export default "__VITE_ASSET__DoGHnYxi__"